<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    <div class="divider w-100 mt-40"></div>
    <div class="participant-columns participant-columns-header w-824 mt-40">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div class="t2-semi-bold">{{ label | translate }}</div>
            @if (!participant && !form.controls.subjectType) {
                <ui-kit-button type="text"
                               [label]="'i18n_af_buttonFillData' | translate"
                               (clickListener)="buildForm()"/>
            }
        </div>
        @if (form.controls.subjectType) {
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ organizationLabelKey | translate }}</div>
                <ui-kit-button type="text"
                               [label]="(collapsed ? 'i18n_af_buttonExpand' : 'i18n_af_buttonCollapse') | translate"
                               (clickListener)="toggleCollapsed()"/>
            </div>
        }
    </div>
    @if (form) {
        <form [formGroup]="form" class="w-824 mt-24">
            @if (showNotMyClient) {
                <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 not-my-client-panel mb-24">
                    <div class="t4">{{ notMyClientLabelKey | translate }}</div>
                    <ui-kit-checkbox [formControl]="form.controls.notMyClient"/>
                </div>
            }
            @if (form.controls.id) {
                <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="id"
                               name="id"/>
                    </mat-form-field>
                </div>
            }
            @if (form.controls.phoneNumberId) {
                <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="phoneNumberId"
                               name="phoneNumberId"/>
                    </mat-form-field>
                </div>
            }
            <div class="participant-columns" [hidden]="collapsed">
                <div class="participant-column">
                    @if (form.controls.subjectType) {
                        <af-dictionary-selector dictionaryName="subject_type"
                                                [control]="form.controls.subjectType"
                                                [predefinedValue]="form.controls?.subjectType?.value ?? participant?.type.toUpperCase()"
                                                [disabled]="disableEditSubjectType()"
                                                label="i18n_af_labelSubjectType"
                                                placeholder="i18n_af_placeholderSubjectType"/>
                    }
                    @if (form.controls.role && creditRole !== 'sender') {
                        <af-dictionary-selector dictionaryName="incident_role"
                                                [control]="form.controls.role"
                                                [excludeFromDictionary]="excludeRoleType"
                                                [disabled]=disableEditRole()
                                                [predefinedValue]="form.controls?.role?.value ?? participant?.incident_role.toLowerCase()"
                                                label="i18n_af_labelIncidentRole"
                                                placeholder="i18n_af_placeholderIncidentRole"/>
                    }
                    @if (form.controls.subjectType && creditRole === 'receiver' && borrowerCategoryControl) {
                        <af-dictionary-selector dictionaryName="borrower_category"
                                                [control]="borrowerCategoryControl"
                                                label="i18n_af_labelBorrowerCategory"
                                                placeholder="i18n_af_placeholderBorrowerCategory"/>
                    }
                    @if (form.controls.surname) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelSurname' | translate }} {{ form.controls.surname.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.surname">
                                <input matInput
                                       commonsNameFormatter
                                       formControlName="surname"
                                       [placeholder]="'i18n_af_placeholderSurname' | translate"
                                       name="surname"/>
                                @if (form.controls.surname.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.surname.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.organizationName) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationName' | translate }} {{ form.controls.organizationName.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.organizationName">
                                <input matInput
                                       commonsNameFormatter
                                       formControlName="organizationName"
                                       [placeholder]="'i18n_af_placeholderOrganizationName' | translate"
                                       name="organizationName"/>
                                @if (form.controls.organizationName.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.organizationName.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.name) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelFirstName' | translate }} {{ form.controls.name.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.name">
                                <input matInput
                                       commonsNameFormatter
                                       formControlName="name"
                                       [placeholder]="'i18n_af_placeholderFirstName' | translate"
                                       name="name"/>
                                @if (form.controls.name.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.name.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.patronymic) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelPatronymic' | translate }} {{ form.controls.patronymic.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.patronymic">
                                <input matInput
                                       commonsNameFormatter
                                       formControlName="patronymic"
                                       [placeholder]="'i18n_af_placeholderPatronymic' | translate"
                                       name="patronymic"/>
                                @if (form.controls.patronymic.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.patronymic.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.iin) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelIin' | translate }} {{ form.controls.iin.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.iin.valid">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderIin' | translate"
                                       formControlName="iin"
                                       name="iin"
                                       mask="000000000000"
                                       [readonly]="isIdentificationNumberReadonly()"/>
                                @if (form.controls.iin.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.iin.hasError('minlength') || form.controls.iin.hasError('maxlength')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationIdNumLength' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.iin.hasError('serverError')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ form.controls.iin.errors.serverError }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form?.controls?.originDate && form?.controls?.subjectType?.value === SubjectType.PERSON) {
                        <af-date-picker-field
                            labelTranslationKey="i18n_af_labelDateOfBirth"
                            placeholderTranslationKey="i18n_af_placeholderDateOfBirth"
                            [minDate]="null"
                            [form]="form?.controls?.originDate"
                            [dateFormats]="DATE_FORMATS"
                            [supportedDateFormat]="['DDMMYYYY','DD.MM.YYYY']"/>
                    }
                    @if (form?.controls?.originDate && form?.controls?.subjectType?.value === SubjectType.ORGANIZATION) {
                        <af-date-picker-field
                            labelTranslationKey="i18n_af_labelRegistrationDate"
                            placeholderTranslationKey="i18n_af_placeholderRegistrationDate"
                            [minDate]="null"
                            [form]="form?.controls?.originDate"
                            [dateFormats]="DATE_FORMATS"
                            [supportedDateFormat]="['DDMMYYYY','DD.MM.YYYY']"/>
                    }
                    @if (form.controls.gender) {
                        <af-dictionary-selector
                            dictionaryName="gender"
                            [control]="form.controls.gender"
                            [predefinedValue]="form.controls?.gender?.value ?? participant?.info?.gender"
                            label="i18n_af_labelGender"
                            placeholder="i18n_af_placeholderGender"/>
                    }
                    @if (form.controls.bin) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelBin' | translate }} {{ form.controls.bin.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.bin">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderBin' | translate"
                                       formControlName="bin"
                                       name="bin"
                                       mask="000000000000"
                                       [readonly]="isIdentificationNumberReadonly()"/>
                                @if (form.controls.bin.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.bin.hasError('minlength') || form.controls.bin.hasError('maxlength')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationIdNumLength' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.country) {
                        <af-dictionary-selector
                            dictionaryName="country"
                            [control]="form.controls.country"
                            [predefinedValue]="form.controls?.country?.value ?? participant?.country"
                            label="i18n_af_labelCountry"
                            placeholder="i18n_af_placeholderCountry"/>
                    }
                    @if (showPhoneComponent && form.controls.phoneNumber) {
                        <af-phone-number
                            [control]="form.controls.phoneNumber"
                            [selectedPhoneInfoControl]="form.controls.selectedPhoneInfo"
                            [predefinedValue]="form.controls?.phoneNumber?.value ?? participant?.phone_number?.number"
                            [strictValidation]="!participant"
                            label="i18n_af_placeholderPhone"/>
                    }
                </div>
                <ng-template #requisiteOrganizationTypeSelector>
                    @if (form.controls.requisiteOrganizationType && mode === 'incident') {
                        <af-dictionary-selector
                            [dictionary]="organizationTypes"
                            [control]="form.controls.requisiteOrganizationType"
                            [predefinedValue]="form.controls.requisiteOrganizationType.value"
                            label="i18n_af_labelOrganizationType"
                            placeholder="i18n_af_placeholderOrganizationType"/>
                    }
                </ng-template>
                <ng-template #accountValueFieldsBlock>
                    @if (areAccountFieldsVisible()) {
                        @if (form.controls.accountStatus) {
                            <af-dictionary-selector
                                dictionaryName="account_status"
                                [control]="form.controls.accountStatus"
                                [predefinedValue]="form.controls?.accountStatus?.value ?? participant?.account?.status"
                                label="i18n_af_labelAccountStatus"
                                placeholder="i18n_af_placeholderAccountStatus"/>
                        }
                        @if (form.controls.accountBalance) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelBalance' | translate }} {{ form.controls.accountBalance.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.accountBalance">
                                    <input matInput
                                           commonsTiynTengeInput
                                           formControlName="accountBalance"
                                           [placeholder]="'i18n_af_placeholderBalance' | translate"
                                           name="accountBalance"/>
                                    @if (form.controls.accountBalance.hasError('required')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.accountBalance.hasError('min')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationBalanceNegative' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.accountCurrency) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <af-dictionary-selector
                                    dictionaryName="currency"
                                    [control]="form.controls.accountCurrency"
                                    [predefinedValue]="form.controls?.accountCurrency?.value ?? participant?.account?.currency"
                                    label="i18n_af_labelCurrency"
                                    placeholder="i18n_af_placeholderCurrency"/>
                            </div>
                        }
                    }
                </ng-template>
                <ng-template #paymentPointBlock>
                    @if (mode === 'incident' && form.controls.paymentPointIssuerBin) {
                        <af-dictionary-selector
                            dictionaryName="bin"
                            [control]="form.controls.paymentPointIssuerBin"
                            [isDependentDictionary]="true"
                            [parentDictionaryFormControl]="form.controls.paymentPointType"
                            [predefinedValue]="form.controls.paymentPointIssuerBin.value"
                            label="i18n_af_labelRequisiteOrganizationName"
                            placeholder="i18n_af_placeholderRequisiteOrganizationName"/>
                    }
                    @if (form.controls.paymentPointType) {
                        <af-dictionary-selector
                            [dictionary]="organizationTypes"
                            [control]="form.controls.paymentPointType"
                            [predefinedValue]="form.controls.paymentPointType.value"
                            label="i18n_af_labelOrganizationType"
                            placeholder="i18n_af_placeholderOrganizationType"/>
                    }
                    @if (form.controls.paymentPointId) {
                        <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <mat-form-field class="w-100 mt-4">
                                <input matInput
                                       readonly
                                       formControlName="paymentPointId"
                                       name="paymentPointId"/>
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.paymentPointNumber) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">
                                {{ 'i18n_af_labelPaymentPointNumber' | translate }}
                                {{ form.controls.paymentPointNumber.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.paymentPointNumber">
                                <input matInput
                                       formControlName="paymentPointNumber"
                                       maxlength="34"
                                       (input)="paymentPointNumberInput($event.target)"
                                       [placeholder]="'i18n_af_placeholderPaymentPointNumber' | translate"/>
                                @if (form.controls.paymentPointNumber.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.paymentPointNumber.hasError('maxlength')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_terminalMaxLength' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.paymentPointNumber.hasError('pattern')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_terminalInvalidFormat' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.paymentPointAddress) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">
                                {{ 'i18n_af_labelPaymentPointAddress' | translate }}
                                {{ form.controls.paymentPointAddress.hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.paymentPointAddress">
                                <input matInput
                                       formControlName="paymentPointAddress"
                                       [placeholder]="'i18n_af_placeholderPaymentPointAddress' | translate"/>
                                @if (form.controls.paymentPointAddress.hasError('required')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.paymentPointStreet) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelPaymentPointStreet' | translate }}</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.paymentPointStreet">
                                <input matInput
                                       formControlName="paymentPointStreet"
                                       [placeholder]="'i18n_af_placeholderPaymentPointStreet' | translate"/>
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.paymentPointHouseNumber) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelPaymentPointHouseNumber' | translate }}</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.paymentPointHouseNumber">
                                <input matInput
                                       formControlName="paymentPointHouseNumber"
                                       [placeholder]="'i18n_af_placeholderPaymentPointHouseNumber' | translate"/>
                            </mat-form-field>
                        </div>
                    }
                </ng-template>
                <div class="participant-column">
                    @if (form.hasError('paymentVictimRequisiteRequired')) {
                        <div class="t5 c-secondary-red-900 mb-16">
                            {{ 'i18n_af_errorPaymentVictimRequisiteRequired' | translate }}
                        </div>
                    }
                    @switch (form.controls.requisiteType?.value) {
                        @case ('ACCOUNT_KZ') {
                            @if (form.controls.accountIssuerBin && mode === 'incident') {
                                <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                    <af-dictionary-selector
                                        #accountIssuerBinSelector
                                        dictionaryName="bin"
                                        [filterDictionaryBy]="['BANK']"
                                        [control]="form.controls.accountIssuerBin"
                                        [predefinedValue]="form.controls.accountIssuerBin.value"
                                        label="i18n_af_labelRequisiteOrganizationName"
                                        placeholder="i18n_af_placeholderRequisiteOrganizationName"/>
                                </div>
                            }
                            <ng-container [ngTemplateOutlet]="requisiteOrganizationTypeSelector"></ng-container>
                        }
                        @case ('CARD_MASK') {
                            @if (form.controls.cardIssuerBin && mode === 'incident') {
                                <af-dictionary-selector
                                    #cardBinIssuerBinSelector
                                    [control]="form.controls.cardIssuerBin"
                                    [predefinedValue]="form.controls.cardIssuerBin.value"
                                    dictionaryName="bin"
                                    [filterDictionaryBy]="['BANK']"
                                    label="i18n_af_labelRequisiteOrganizationName"
                                    placeholder="i18n_af_placeholderRequisiteOrganizationName"/>
                            }
                            <ng-container [ngTemplateOutlet]="requisiteOrganizationTypeSelector"></ng-container>
                        }
                        @case ('ELECTRONIC_WALLET') {
                            @if (form.controls.walletIssuerBin && mode === 'incident') {
                                <af-dictionary-selector
                                    dictionaryName="bin"
                                    [filterDictionaryBy]="['PAYM']"
                                    [control]="form.controls.walletIssuerBin"
                                    [predefinedValue]="participant?.wallet?.issuer_bin"
                                    label="i18n_af_labelRequisiteOrganizationName"
                                    placeholder="i18n_af_placeholderRequisiteOrganizationName"/>
                            }
                        }
                        @case ('PAYMENT_POINT') {
                            <ng-container [ngTemplateOutlet]="paymentPointBlock"/>
                        }
                        @case ('ACCOUNT_FOREIGN_BANK') {
                            @if (form.controls.foreignIssuerBin && mode === 'incident') {
                                <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                    <div class="t5 c-primary-gray-600">
                                        {{ 'i18n_af_labelRequisiteOrganizationName' | translate }}
                                        {{ form.controls.foreignIssuerBin.hasValidator(Validators.required) ? '*' : '' }}
                                    </div>
                                    <mat-form-field class="w-100 mt-4"
                                                    [class.value-not-empty]="form.value.foreignIssuerBin && form.controls.foreignIssuerBin.valid">
                                        <input matInput
                                               formControlName="foreignIssuerBin"
                                               (input)="onForeignIssuerBinInput($event)"
                                               [placeholder]="'i18n_af_placeholderRequisiteOrganizationName' | translate"
                                               name="foreignIssuerBin"/>
                                        @if (form.controls.foreignIssuerBin.hasError('required')) {
                                            <mat-error
                                                class="c-secondary-red-900">
                                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            }
                        }
                    }
                    @if (form.controls.requisiteType) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <af-dictionary-selector
                                dictionaryName="requisite_type"
                                [control]="form.controls.requisiteType"
                                [excludeFromDictionary]="excludedRequisiteTypes"
                                label="i18n_af_labelRequisiteType"
                                placeholder="i18n_af_placeholderRequisiteType"/>
                        </div>
                    }
                    @if (form.controls.requisiteType?.value === 'ACCOUNT_KZ') {
                        @if (form.controls.accountId) {
                            <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <mat-form-field class="w-100 mt-4">
                                    <input matInput
                                           readonly
                                           formControlName="accountId"
                                           name="accountId"/>
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.iban) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.iban.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.iban && form.controls.iban.valid && !hasRequisiteConflict">
                                    <input matInput
                                           formControlName="iban"
                                           [maxlength]="KZ_IBAN_LENGTH"
                                           [readonly]="isIbanReadonly()"
                                           [errorStateMatcher]="requisiteConflictErrorStateMatcher"
                                           (input)="onIbanInput($event)"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="iban"/>
                                    @if (form.controls.iban.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthIbanKz' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.refundBin) {
                            <af-dictionary-selector
                                dictionaryName="bin"
                                [control]="form.controls.refundBin"
                                [predefinedValue]="form.controls.refundBin.value"
                                [filterDictionaryBy]="['BANK']"
                                label="i18n_af_labelRefundBankName"
                                placeholder="i18n_af_placeholderRefundBankName"/>
                        }
                        <ng-container [ngTemplateOutlet]="accountValueFieldsBlock"/>
                    }
                    @if (form.controls.requisiteType?.value === 'CARD_MASK') {
                        @if (form.controls.cardMaskNumber) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelCardMask' | translate }} {{ form.controls.cardMaskNumber.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.cardMaskNumber && form.controls.cardMaskNumber.valid && !hasRequisiteConflict">
                                    @if (!isOtherIncidentType && !isCompromisedPaymentInstrumentType) {
                                        <input
                                            matInput
                                            formControlName="cardMaskNumber"
                                            [dropSpecialCharacters]="false"
                                            [showMaskTyped]="true"
                                            [specialCharacters]="['#']"
                                            [errorStateMatcher]="requisiteConflictErrorStateMatcher"
                                            (input)="onCardInput($event)"
                                            mask="000000######0000"
                                            name="cardMaskNumber"/>
                                    }
                                    @if (isOtherIncidentType || isCompromisedPaymentInstrumentType) {
                                        <input
                                            matInput
                                            formControlName="cardMaskNumber"
                                            [errorStateMatcher]="requisiteConflictErrorStateMatcher"
                                            (input)="onFullCardInput($event)"
                                            inputmode="numeric"
                                            placeholder="1234 5678 9012 3456"
                                            name="cardMaskNumber"/>
                                    }
                                    @if (form.controls.cardMaskNumber.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.cardMaskNumber.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationCardMaxLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.cardMaskNumber.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationCardMinLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.cardMaskNumber.hasError('invalidCard')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationInvalidCardError' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.iban) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.iban.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.iban && form.controls.iban.valid && !hasRequisiteConflict">
                                    <input matInput
                                           formControlName="iban"
                                           [maxlength]="KZ_IBAN_LENGTH"
                                           [readonly]="isIbanReadonly()"
                                           [errorStateMatcher]="requisiteConflictErrorStateMatcher"
                                           (input)="onIbanInput($event)"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="iban"/>
                                    @if (form.controls.iban.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthIbanKz' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <ng-container [ngTemplateOutlet]="accountValueFieldsBlock"/>
                        }
                    }
                    @if (form.controls.requisiteType?.value === 'ELECTRONIC_WALLET') {
                        @if (form.controls.walletId) {
                            <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <mat-form-field class="w-100 mt-4">
                                    <input matInput
                                           readonly
                                           formControlName="walletId"
                                           name="walletId"/>
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.walletNumber) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div class="t5 c-primary-gray-600">
                                    {{ 'i18n_af_labelWalletNumber' | translate }}
                                    {{ form.controls.walletNumber.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.walletNumber && form.controls.walletNumber.valid">
                                    <input matInput
                                           formControlName="walletNumber"
                                           (input)="onWalletNumberInput($event)"
                                           [placeholder]="'i18n_af_placeholderWalletNumber' | translate"
                                           name="walletNumber"/>
                                    @if (form.controls.walletNumber.hasError('minlength')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthWallet' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.walletNumber.hasError('maxlength')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthWallet' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.walletNumber.hasError('pattern')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationWalletPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (showWalletIbanField && form.controls.iban) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.iban.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.iban && form.controls.iban.valid && !hasRequisiteConflict">
                                    <input matInput
                                           formControlName="iban"
                                           [maxlength]="KZ_IBAN_LENGTH"
                                           [readonly]="isIbanReadonly()"
                                           [errorStateMatcher]="requisiteConflictErrorStateMatcher"
                                           (input)="onIbanInput($event)"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="iban"/>
                                    @if (form.controls.iban.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthIbanKz' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.iban.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <ng-container [ngTemplateOutlet]="accountValueFieldsBlock"/>
                        }
                    }
                    @if (form.controls.requisiteType?.value === 'ACCOUNT_FOREIGN_BANK') {
                        @if (form.controls.foreignAccountId) {
                            <div fxHide fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <mat-form-field class="w-100 mt-4">
                                    <input matInput
                                           readonly
                                           formControlName="foreignAccountId"
                                           name="foreignAccountId"/>
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.iban) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.foreignIban.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.foreignIban && form.controls.foreignIban.valid">
                                    <input matInput
                                           formControlName="foreignIban"
                                           [maxlength]="IBAN_MAX_LENGTH"
                                           (input)="onForeignIbanInput($event)"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="iban"/>
                                    @if (form.controls.foreignIban.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.foreignIban.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthForeignIban' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.foreignIban.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.foreignIban.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }
                    @if (form.controls.requisiteType) {
                        @for (block of extraRequisiteBlocks; track block) {
                            <ng-container [ngTemplateOutlet]="requisiteBlockTemplate(block)"/>
                        }
                    }
                </div>
            </div>
        </form>
    }
</div>
